import { create } from 'zustand';
import { getMetronDevicesApi } from '../../../api/api';

export const useMetronDevicesStore = create((set) => ({
  items: [],
  total: 0,
  firmware: null,
  summary: null,
  isLoading: false,
  loaded: false,
  error: null,

  fetchDevices: async ({ page, count, serialNumber, firmwareStatus, sortBy, sortOrder } = {}) => {
    set({ isLoading: true, error: null });

    await getMetronDevicesApi({
      page,
      count,
      serialNumber,
      firmwareStatus,
      sortBy,
      sortOrder,
      dataCb: (res) => {
        set({
          items: res?.items ?? [],
          total: res?.count ?? 0,
          firmware: res?.firmware ?? null,
          summary: res?.summary ?? null,
          isLoading: false,
          loaded: true,
        });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },
}));
